import React from 'react'
import './Industries.css'
import drop from '../Images/industry-drop.webp'

export const Industries = () => {
  return (
    <div className='industries-div'>
<div className="d_flex">
   {/* <div className="menu__col menu__cta__wrapper dflex">
      <div className="lg_text_wrapper">
         <span>Diverse Capabilities</span>
         <p className="para">that deploy customized solutions in a wide range of
            industries
         </p>
      </div>
      <div className="industry_left_img">
         <div className="imag_panel"> <a href="#" className=""><img src={drop} alt="Supply Chain Industry boom in India"/> </a></div>
         <div className="bottom-text space-between">
            <div className="read_our"> Read our developments that has helped the <a  className="">Supply Chain</a> Industry boom in India</div>
            <div className="cirl_arw"> <a href="/" className=""><i className="fa-solid fa-chevron-right"></i></a></div>
         </div>
      </div>
   </div> */}
   <div className="menu__col">
      <div className="cl-inner">
         <div className="left_icon_panel">
            <figure> <img src="/IndustriesIcon/on-demand-icn.svg" alt="On demand App development"/></figure>
         </div>
         <div className="right_text_panel">
            <div className="heading4">On Demand</div>
         </div>
      </div>
      <div className="cl-inner">
         <div className="left_icon_panel">
            <figure> <img src="/IndustriesIcon/healthcare-icn.svg" alt="Healthcare Software development Services"/></figure>
         </div>
         <div className="right_text_panel">
            <div className="heading4">Healthcare</div>
         </div>
      </div>
      <div className="cl-inner">
         <div className="left_icon_panel">
            <figure> <img src="/IndustriesIcon/restaurants-icn.svg" alt="Restaurant Software development Services"/></figure>
         </div>
         <div className="right_text_panel">
            <div className="heading4">Restaurant</div>
         </div>
      </div>
      <div className="cl-inner">
         <div className="left_icon_panel">
            <figure> <img src="/IndustriesIcon/entertainment-icn.svg" alt="entertainment Software development Services"/></figure>
         </div>
         <div className="right_text_panel">
            <div className="heading4">Entertainment</div>
         </div>
      </div>
      <div className="cl-inner">
         <div className="left_icon_panel">
            <figure> <img src="/IndustriesIcon/travel-icn.svg" alt="Travel App development Services"/></figure>
         </div>
         <div className="right_text_panel">
            <div className="heading4">Travel</div>
         </div>
      </div>
      <div className="cl-inner">
         <div className="left_icon_panel">
            <figure> <img src="/IndustriesIcon/e-scooter-icn.svg" alt="E-scooter App development Services"/></figure>
         </div>
         <div className="right_text_panel">
            <div className="heading4">E-scooter</div>
         </div>
      </div>
      <div className="cl-inner">
         <div className="left_icon_panel">
            <figure> <img src="/IndustriesIcon/events-icn.svg" alt="Events app development Services"/></figure>
         </div>
         <div className="right_text_panel">
            <div className="heading4">Events</div>
         </div>
      </div>
     
   </div>
   <div className="menu__col">
      <div className="cl-inner">
         <div className="left_icon_panel">
            <figure> <img src="/IndustriesIcon/mCommerce-icn.svg" alt="eCommerce Software development Services"/></figure>
         </div>
         <div className="right_text_panel">
            <div className="heading4">eCommerce</div>
         </div>
      </div>
      <div className="cl-inner">
         <div className="left_icon_panel">
            <figure> <img src="/IndustriesIcon/SaaS-icn.svg" alt="SaaS app development Services"/></figure>
         </div>
         <div className="right_text_panel">
            <div className="heading4">SaaS</div>
         </div>
      </div>
      <div className="cl-inner">
         <div className="left_icon_panel">
            <figure> <img src="/IndustriesIcon/sports-icn.svg" alt="mobile Games app development Services"/></figure>
         </div>
         <div className="right_text_panel">
            <div className="heading4">Games</div>
         </div>
      </div>
      <div className="cl-inner">
         <div className="left_icon_panel">
            <figure> <img src="/IndustriesIcon/wellness-icn.svg" alt="Wellness Software development Services"/></figure>
         </div>
         <div className="right_text_panel">
            <div className="heading4">Wellness</div>
         </div>
      </div>
      <div className="cl-inner">
         <div className="left_icon_panel">
            <figure> <img src="/IndustriesIcon/finance-icn.svg" alt="Finance Software development Services"/></figure>
         </div>
         <div className="right_text_panel">
            <div className="heading4">Finance</div>
         </div>
      </div>
      <div className="cl-inner">
         <div className="left_icon_panel">
            <figure> <img src="/IndustriesIcon/politics-icn.svg" alt="Politics Software development Services"/></figure>
         </div>
         <div className="right_text_panel">
            <div className="heading4">Politics</div>
         </div>
      </div>
      <div className="cl-inner">
         <div className="left_icon_panel">
            <figure> <img src="/IndustriesIcon/social-media-icn.svg" alt="Social Networking Software development Services"/></figure>
         </div>
         <div className="right_text_panel">
            <div className="heading4">Social Networking</div>
         </div>
      </div>
     
   </div>
   <div className="menu__col">
      <div className="cl-inner">
         <div className="left_icon_panel">
            <figure> <img src="/IndustriesIcon/real-state-icn.svg" alt="Real Estate app development Services"/></figure>
         </div>
         <div className="right_text_panel">
            <div className="heading4">Real Estate</div>
         </div>
      </div>
      <div className="cl-inner">
         <div className="left_icon_panel">
            <figure> <img src="/IndustriesIcon/mLearning-icn.svg" alt="Education app development Services"/></figure>
         </div>
         <div className="right_text_panel">
            <div className="heading4">Education</div>
         </div>
      </div>
      <div className="cl-inner">
         <div className="left_icon_panel">
            <figure> <img src="/IndustriesIcon/news-icn.svg" alt="News app development Services"/></figure>
         </div>
         <div className="right_text_panel">
            <div className="heading4">News</div>
         </div>
      </div>
      <div className="cl-inner">
         <div className="left_icon_panel">
            <figure> <img src="/IndustriesIcon/logistics-menu-icn.svg" alt="Logistics Software development Services"/></figure>
         </div>
         <div className="right_text_panel">
            <div className="heading4">Logistics</div>
         </div>
      </div>
      <div className="cl-inner">
         <div className="left_icon_panel">
            <figure> <img src="/IndustriesIcon/aviation-icn.svg" alt="Aviation Software development Services"/></figure>
         </div>
         <div className="right_text_panel">
            <div className="heading4">Aviation</div>
         </div>
      </div>
      <div className="cl-inner">
         <div className="left_icon_panel">
            <figure> <img src="/IndustriesIcon/agricultural-icn.svg" alt="Agriculture Software development Services"/></figure>
         </div>
         <div className="right_text_panel">
            <div className="heading4">Agriculture</div>
         </div>
      </div>
      <div className="cl-inner">
         <div className="left_icon_panel">
            <figure> <img src="/IndustriesIcon/ev-icn.svg" alt="electric vehicle software development"/></figure>
         </div>
         <div className="right_text_panel">
            <div className="heading4">EV</div>
         </div>
      </div>
      
   </div>
   <div className="menu__col">

<div className="cl-inner">
         <div className="left_icon_panel">
            <figure> <img src="/IndustriesIcon/automotive.svg" alt="Automotive Software development Services"/></figure>
         </div>
         <div className="right_text_panel">
            <div className="heading4">Automotive</div>
         </div>
      </div>
      <div className="cl-inner">
         <div className="left_icon_panel">
            <figure> <img src="/IndustriesIcon/manufacturing-head-icon.svg" alt="Manufacturing software development"/></figure>
         </div>
         <div className="right_text_panel">
            <div className="heading4">Manufacturing</div>
         </div>
      </div>
      <div className="cl-inner">
         <div className="left_icon_panel">
            <figure> <img src="/IndustriesIcon/banks.svg" alt="Banking Software development Services"/></figure>
         </div>
         <div className="right_text_panel">
            <div className="heading4">Banking</div>
         </div>
      </div>
      <div className="cl-inner">
         <div className="left_icon_panel">
            <figure> <img src="/IndustriesIcon/insurance-head-icon.svg" alt="Insurance software development"/></figure>
         </div>
         <div className="right_text_panel">
            <div className="heading4">Insurance</div>
         </div>
      </div>
      <div className="cl-inner">
         <div className="left_icon_panel">
            <figure> <img src="/IndustriesIcon/retail-head.svg" alt="Retail Software Development Services"/></figure>
         </div>
         <div className="right_text_panel">
            <div className="heading4">Retail </div>
         </div>
      </div>
      <div className="cl-inner">
         <div className="left_icon_panel">
            <figure> <img src="/IndustriesIcon/oil-and-gas.svg" alt="Oil and Gas Software development Services"/></figure>
         </div>
         <div className="right_text_panel">
            <div className="heading4">Oil and Gas</div>
         </div>
      </div>
      <div className="cl-inner">
         <div className="left_icon_panel">
            <figure> <img src="/IndustriesIcon/telecom-head-icon.svg" alt="Telecom software development"/></figure>
         </div>
         <div className="right_text_panel">
            <div className="heading4">Telecom</div>
         </div>
      </div>
      <div className="cl-inner">
         <div className="left_icon_panel">
            <figure> <img src="/IndustriesIcon/construction-head-icon.svg" alt="Construction Software Development Services"/></figure>
         </div>
         <div className="right_text_panel">
            <div className="heading4">Construction</div>
         </div>
      </div>
</div>
</div>




    </div>
  )
}
